import React from "react";
import './ProductsRaccomandations.css';
import {useSelector } from "react-redux";
import ProductCard from "../ProductCard/ProductCard";
import Slider from "react-slick";

const ProductsRaccomandations = () => {
  const triggers = useSelector(state => state.config.triggers);
  const display = useSelector(state => state.config.display);
  const isMobile = useSelector(state => state.isMobile);
  const settings = {
    dots: false,
    infinite: false,
    speed: 200,
    slidesToShow: isMobile || display==="half-screen"?2:4,
    slidesToScroll: isMobile || display==="half-screen"?2:4
  };

  return(
    <div className="products-raccomandations">
      <div className="label "> Trending Products </div>
      <Slider {...settings}>
        {(triggers.raccomandationsProducts?triggers.raccomandationsProducts:[]).map((item,index)=>
          <ProductCard value = {item} key={'product_'+index} />
        )}
      </Slider >
    </div>
  )
};

export default ProductsRaccomandations;